//- Remunerations headers for employee details tab
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
    },
    {
        text: 'Año',
        value: 'period_year',
        sortable: true,
        align: 'right',
    },
    {
        text: 'Mes',
        value: 'period_month',
        format: 'date-month',
        classes: 'text-capitalize',
        sortable: true,
        width: '40%',
    },
    {
        text: 'creación',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
        sortable: true,
        width: '15%',
    },
    {
        text: 'modificación',
        value: 'updated_at',
        align: 'right',
        format: 'datetime',
        sortable: true,
        width: '15%',
    },
]
